import {deliveryTheme, dark as gwcDarkTheme} from '@yandex-delivery/blocks/theme'
import type {Theme} from 'src/shared/hooks/useTheme'

/** Токены тёмной темы из Figma (node-id=30868:8414), поверх GWC dark */
const FIGMA_DARK_COLOR_SCHEME = {
  background: '#191918',
  bgMinor: '#302F2D',
  bgMain: '#191918',
  text: '#E0DEDA',
  textMinor: 'rgba(224, 222, 218, 0.5)',
  line: 'rgba(245, 244, 242, 0.2)',
  control: '#FCE000',
  controlMinor: 'rgba(245, 244, 242, 0.1)',
} as const

export function getGwcTheme(mode: Theme, dir: 'ltr' | 'rtl') {
  if (mode === 'light') {
    return {...deliveryTheme, dir}
  }

  return {
    ...deliveryTheme,
    ...gwcDarkTheme,
    dir,
    colorScheme: {
      ...gwcDarkTheme.colorScheme,
      ...FIGMA_DARK_COLOR_SCHEME,
    },
  }
}
